<template>
    <div class="container-configuration-reserves-permissions">
        <ui-toogle-debug-mode />
    </div>
</template>
<script>
	import { uiToogleDebugMode } from '@/components/ui-facilita/configurations'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'


	export default {
		name: 'integrations-advanced',

		components: {
			uiToogleDebugMode
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
